import {
  OR_REGISTRATION_TOGGLE_PANEL, ADDRESS_PANEL, PHONE_PANEL, FREQUENCY_PANEL, SLOT_PANEL, PAYMENT_PANEL, FINAL,
} from '../../actions/registration/registrationFormPanels';
import {
  OR_RECEIVE_INIT_REGISTRATION_DATA,
  OR_CHOOSE_ADDRESS,
  OR_ENTER_PHONE,
  OR_CHOOSE_FREQUENCY,
  OR_CHOOSE_SLOT,
  OR_REQUEST_SLOTS,
  OR_SELECT_PAYMENT_METHOD,
  OR_REGISTRATION_RESET_DATA,
} from '../../actions/registration/ordersReservedRegistration';

export const initialState = {
  activePanel: ADDRESS_PANEL,
  leastAvailablePanel: ADDRESS_PANEL,
  hideMobilePhonePanel: false,
};

const hidePanel = (state) => ({ ...state, activePanel: null });

const activatePanel = (state, nextPanel) => ({
  ...state,
  activePanel: nextPanel,
  leastAvailablePanel: nextPanel,
});

const showPanel = (state, nextPanel) => ({ ...state, activePanel: nextPanel });

const finishForm = (state) => ({
  ...state,
  activePanel: null,
  leastAvailablePanel: FINAL,
});

const isEditingFinished = state => state.leastAvailablePanel === FINAL;

const togglePanel = (state, action) => {
  const isPanelDisabled = action.panelKey > state.leastAvailablePanel;
  const hidePanelRequest = action.panelKey === undefined;

  if (!hidePanelRequest && !isPanelDisabled) {
    return showPanel(state, action.panelKey);
  }
  if (isEditingFinished(state)) {
    return hidePanel(state);
  }
  return state;
};

const continueEditing = (state, action, nextPanel) => {
  if (action.hasChanged) {
    return activatePanel(state, nextPanel);
  } else if (isEditingFinished(state)) {
    return hidePanel(state);
  }
  return showPanel(state, nextPanel);
};

const continueEditingWithoutCheckingIfChanged = (state, nextPanel) => {
  if (isEditingFinished(state)) {
    return hidePanel(state);
  }
  return activatePanel(state, nextPanel);
};

export default function panelsReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REGISTRATION_TOGGLE_PANEL:
      return togglePanel(state, action);
    case OR_RECEIVE_INIT_REGISTRATION_DATA:
      return {
        ...state,
        hideMobilePhonePanel: !!(action.data.smsEnabled && action.data.smsNumber),
      };
    case OR_CHOOSE_ADDRESS:
      return continueEditing(state, action, state.hideMobilePhonePanel ? FREQUENCY_PANEL : PHONE_PANEL);
    case OR_ENTER_PHONE:
      return continueEditingWithoutCheckingIfChanged(state, FREQUENCY_PANEL);
    case OR_CHOOSE_FREQUENCY:
      return continueEditing(state, action, SLOT_PANEL);
    case OR_CHOOSE_SLOT:
      return continueEditing(state, action, PAYMENT_PANEL);
    case OR_SELECT_PAYMENT_METHOD:
      return finishForm(state);
    case OR_REQUEST_SLOTS:
      return { ...state, leastAvailablePanel: SLOT_PANEL };
    case OR_REGISTRATION_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
